<!--
 * @Author: tiandi
 * @Date: 2022-01-19 16:01:07
 * @LastEditTime: 2024-07-09 10:35:18
 * @LastEditors: dyl
 * @Description: 工作台
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-workBench/index.vue
-->
<template>
  <section class="main-page">
    <wn-template
      :list-query.sync="listQuery"
      :filter-query-list="filterQueryList"
      :search-key-info="searchKeyInfo"
      @fetchData="getDataList"
    >
      <div slot="funBtn" class="benchTop">
        <w-row>
          <w-col :span="4">
            <w-row>
              <w-col :span="12">
                <span>未完成：</span>
                <span class="bold">{{ analysisInfo.UnFinishedNum }}</span>
              </w-col>
              <w-col :span="12" class="c-error">
                <span>超时未完成：</span>
                <span class="bold">{{ analysisInfo.overTime }}</span>
              </w-col>
            </w-row>
          </w-col>
          <w-col :span="20">
            <w-row>
              <w-col :span="1">
                <span class="ver-line"></span>
              </w-col>
              <w-col :span="3">
                <span>我的工作：</span>
                <span class="bold">{{ analysisInfo.myWork }}</span>
              </w-col>
              <w-col :span="3" class="c-error">
                <span>超时未完成：</span>
                <span class="bold">{{ analysisInfo.myOverTime }}</span>
              </w-col>
              <w-col :span="2">
                <span>待检查：</span>
                <span class="bold">{{ analysisInfo.DJCSL }}</span>
              </w-col>
              <w-col :span="2">
                <span>待下发：</span>
                <span class="bold">{{ analysisInfo.DXFSL }}</span>
              </w-col>
              <w-col :span="2">
                <span>待整改：</span>
                <span class="bold">{{ analysisInfo.DZGSL }}</span>
              </w-col>
              <w-col :span="2">
                <span>待评价：</span>
                <span class="bold">{{ analysisInfo.DPJSL }}</span>
              </w-col>
              <w-col :span="5">
                <w-checkbox v-model="onlyMywork" @change="setOnlyWork()"
                  >只显示我的工作</w-checkbox
                >
              </w-col>
            </w-row>
          </w-col>
        </w-row>
      </div>
      <div class="mt-10">
        <w-row v-win-loading="loading" :gutter="10">
          <w-col :span="12">
            <div class="flex mt-10 flex-between">
              <span> 检查任务列表： </span>
              <span>
                <w-dropdown
                  v-if="showAddButton"
                  trigger="click"
                  style="margin-left: 10px"
                  size="small"
                >
                  <w-button size="small">
                    新增检查
                    <i class="w-icon-arrow-bottom"></i>
                  </w-button>
                  <w-dropdown-menu slot="dropdown-menu">
                    <w-dropdown-menu-item
                      v-for="item in checkMethod"
                      :key="item.MJDM"
                      @click="addNewCheck(item.MJDM)"
                      >{{ item.MJMC }}</w-dropdown-menu-item
                    >
                  </w-dropdown-menu>
                </w-dropdown>
                <w-dropdown
                  trigger="click"
                  style="margin-left: 10px"
                  size="small"
                >
                  <w-button size="small" type="primary">
                    导出
                    <i class="w-icon-arrow-bottom"></i>
                  </w-button>
                  <w-dropdown-menu slot="dropdown-menu">
                    <w-dropdown-menu-item @click="exportFile('EXCEL')"
                      >EXCEL</w-dropdown-menu-item
                    >
                    <w-dropdown-menu-item @click="exportFile('PDF')"
                      >PDF</w-dropdown-menu-item
                    >
                  </w-dropdown-menu>
                </w-dropdown>
                <w-button style="margin-left: 10px" size="small" @click="print"
                  >打印</w-button
                >
                <more-cols
                  class="wn-fr"
                  style="margin-left: 8px"
                  name="QcworkBench"
                  :show-table-col-list="tableColumns"
                  :show-table-check-list.sync="showTableCheckList"
                  :zkjb.sync="listQuery.Zkjb"
                  @getLastCheckList="getLastCheckList"
                ></more-cols>
              </span>
            </div>
            <w-table
              ref="leftTab"
              :data="tableData"
              highlight-current-row
              border
              class="mt-5"
              stripe
              height="calc(100vh - 260px)"
              @current-change="handleCurrentChange"
            >
              <w-table-column
                type="index"
                label="序号"
                width="65"
                align="center"
              ></w-table-column>
              <w-table-column
                v-for="item in newTableList"
                :key="item.key"
                :prop="item.key"
                :label="item.name"
                :width="item.width"
                :min-width="item.minWidth"
                :align="item.align"
                :sortable="item.sortable"
                :sort-by="[item.key]"
              >
                <template slot-scope="scope">
                  <span v-if="item.key == 'RWLXMC'">
                    <w-tag
                      v-if="scope.row.RWLX == 10"
                      type="error"
                      :plain="false"
                      size="small"
                      class="cursor"
                    >
                      待检查
                    </w-tag>
                    <w-tag
                      v-if="scope.row.RWLX == 20"
                      type="warning"
                      :plain="false"
                      size="small"
                      class="cursor"
                    >
                      待下发
                    </w-tag>
                    <w-tag
                      v-if="scope.row.RWLX == 30"
                      type="primary"
                      :plain="false"
                      size="small"
                      class="cursor"
                    >
                      待整改
                    </w-tag>
                    <w-tag
                      v-if="scope.row.RWLX == 40"
                      type="success"
                      :plain="false"
                      size="small"
                      class="cursor"
                    >
                      待评价
                    </w-tag>
                  </span>
                  <span v-else-if="item.key == 'JZSJ'">
                    {{
                      scope.row['JZSJ'] == '2000-01-01' ? '' : scope.row['JZSJ']
                    }}
                  </span>
                  <span
                    v-else-if="item.key === 'JCJG' && scope.row.JCFS === 1024"
                  >
                    {{ addPercentage(scope.row.JCJG) }}
                  </span>
                  <span v-else>
                    {{ scope.row[item.key] }}
                  </span>
                </template>
              </w-table-column>
              <w-table-column
                label="操作"
                align="center"
                width="120"
                fixed="right"
              >
                <template slot-scope="scope">
                  <w-button
                    v-if="scope.row.RWLX == 10"
                    v-throttle="1000"
                    type="text"
                    :class="scope.row.SFDJ === 1 ? 'red-item' : ''"
                    :disabled="
                      !canBeStartCheck(scope.row) ||
                      (scope.row.SFDJ == 1 && scope.row.DJZT == 1)
                    "
                    @click.native.stop="onStartCheck(scope.row)"
                  >
                    {{ scope.row.SFDJ === 1 ? '检查申请' : '检查' }}
                  </w-button>
                  <w-button
                    v-else-if="scope.row.RWLX == 20"
                    type="text"
                    :disabled="!canXF"
                    @click.native.stop="patchPlan(scope.row)"
                    >下发</w-button
                  >
                  <w-button
                    v-else-if="scope.row.RWLX == 30"
                    type="text"
                    @click.native.stop="rectification(scope.row)"
                    >整改</w-button
                  >
                  <w-button
                    v-else
                    type="text"
                    :disabled="!canPJ"
                    @click.native.stop="judgeAction(scope.row)"
                    >评价</w-button
                  >
                </template>
              </w-table-column>
            </w-table>
          </w-col>
          <w-col :span="12">
            <div class="flex mt-10 flex-between">
              <span> 检查结果与问题整改明细： </span>
              <more-cols
                class="wn-fr"
                style="margin-left: 8px"
                name="QcworkBench1"
                :show-table-col-list="tableColumns1"
                :show-table-check-list.sync="showTableCheckList1"
                :zkjb.sync="listQuery.Zkjb"
                @getLastCheckList="getLastCheckList1"
              ></more-cols>
            </div>
            <w-table
              ref="rightTab"
              :data="proTableData"
              highlight-current-row
              border
              class="mt-5"
              stripe
              height="calc(100vh - 260px)"
              :header-cell-style="{ 'text-align': 'center' }"
            >
              <w-table-column
                v-for="item in newTableList1"
                :key="item.key"
                :prop="item.key"
                :label="item.name"
                :width="item.width"
                :min-width="item.minWidth"
                :align="item.align"
              >
                <template slot-scope="scope">
                  <span v-if="item.key === 'ZGLX'">
                    <span v-if="scope.row.ZGLX == 0"> 书面整改 </span>
                    <span v-if="scope.row.ZGLX == 1"> 及时整改 </span>
                  </span>
                  <span v-else>
                    {{ scope.row[item.key] }}
                  </span>
                </template>
              </w-table-column>
            </w-table>
          </w-col>
        </w-row>
      </div>
    </wn-template>
  </section>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { pageSizes } from '@/common/settings/pageSettings'
import WnTemplate from '@/common/components/WnTemplate'
import { DownFile, Print } from '@/common/utils/download'
import commonMixin from '@/apps/modules/common/_mixins/index.js'
import { CHECK_METHOD_TYPE_CODE } from '@/apps/modules/common/constants/dictKeys'
import AddTaskDialog from '@/apps/modules/qc-check/check/_components/dialog/AddTaskDialog.vue'
import PatchPlanDialog from '@/apps/modules/qc-qualityImprovement/rectification/_components/dialog/detailDialog.vue'
import QcRectificationDetail from '@/apps/modules/qc-rectification/analyse/_components/QcRectificationDetail.vue'
import JudgeDailog from '@/apps/modules/qc-rectification/qualityImprovementEvaluation/_components/dialog/detailDialog.vue'
import '@/common/directive/throttle'
import QualityImprovementDialog from './_components/dialog/QualityImprovementDialog.vue'
import WorkBenchZG from './_components/dialog/workBenchZG.vue'
import workBenchGZPJ from './_components/dialog/workBenchGZPJ.vue'
import PdfDialog from '@/common/components/Dialog/pdfDialog.vue'
import MoreCols from '@/common/components/MoreCols'
import { GetJHJCBDList } from './_api/index'
import { getTableCheckColumns } from '@/common/utils'
import ApplyDialog from '@/common/components/Dialog/ApplyDialog.vue'
import moment from 'moment'

export default {
  name: 'QcworkBench',
  components: { WnTemplate, MoreCols },
  mixins: [commonMixin],
  data() {
    return {
      UserInfo: {},
      pageSizes: pageSizes,
      config: {
        select: false
      },
      showTableCheckList: [],
      showTableCheckList1: [],
      newTableList: [],
      newTableList1: [],
      tableColumns: [],
      tableColumns1: [],
      tableData: [],
      listQuery: {
        StartTime: '',
        EndTime: '',
        Zkjb: '',
        ORGID: '',
        Jcfw: '',
        JHMC: '',
        WCQK: '',
        Bddms: '',
        Ywlx: '',
        HospitalCode: ''
      },
      filterQueryList: [
        {
          conditionCode: 'StartTime,EndTime', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '督查时间', // 更多筛选-名称
          keepChoosing: true, // 更多筛选-是否可取消选择
          conditionType: 'MONTH_QUARTER_HALF_YEAR_SELECT', // 查询条件字段类型
          hide: false,
          dataList: []
        },
        {
          conditionCode: 'Zkjb', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '质控级别', // 更多筛选-名称
          keepChoosing: true, // 更多筛选-是否可取消选择
          conditionType: 'DYNAMIC_SELECTION', // 查询条件字段类型
          hide: false,
          clearable: false,
          dataList: [],
          callback: (val, node) => {
            this.listQuery.Zkjb = val
            this.changeDCBM(val)
          }
        },
        {
          conditionCode: 'ORGID', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '督查部门', // 更多筛选-名称
          keepChoosing: true, // 更多筛选-是否可取消选择
          conditionType: 'DYNAMIC_TREE', // 查询条件字段类型
          isMulti: false,
          default: '',
          clearable: false,
          hide: false,
          dataList: [],
          callback: (val, node, data) => {
            if (data) {
              let hospitalCode = data.map((m) => m.hospitalCode)?.join(',')
              this.listQuery.HospitalCode =
                hospitalCode || this.$store.state.user.HospitalCode
            }
            this.listQuery.ORGID = val
          }
        },
        {
          conditionCode: 'Jcfw', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '受检科室', // 更多筛选-名称
          keepChoosing: true, // 更多筛选-是否可取消选择
          conditionType: 'POPOVER_SELECT', // 查询条件字段类型
          isMulti: true,
          flexSelect: true,
          hide: false,
          dataList: [],
          callback: (val, code) => {
            this.listQuery.Jcfw = val
            this.getJCBD()
            this.getDataList()
          }
        },
        {
          conditionCode: 'Bddms', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '检查表单', // 更多筛选-名称
          keepChoosing: true, // 更多筛选-是否可取消选择
          conditionType: 'POPOVER_JCBD_SELECT', // 查询条件字段类型
          isMulti: true,
          Bhty: true,
          flexSelect: true,
          hide: false,
          clearable: true,
          filterable: true,
          dataList: [],
          callback: (val, code) => {
            this.listQuery.Bddms = val
            this.getDataList()
          }
        },
        {
          conditionCode: 'Ywlx', // 更多筛选对应字段&查询条件listQuery对应的key
          conditionName: '状态', // 更多筛选-名称
          keepChoosing: true, // 更多筛选-是否可取消选择
          conditionType: 'DYNAMIC_SELECTION', // 查询条件字段类型
          isMulti: true,
          hide: false,
          clearable: true,
          dataList: [
            { selectionCode: '1', selectionName: '待检查' },
            { selectionCode: '2', selectionName: '待下发' },
            { selectionCode: '3', selectionName: '待整改' },
            { selectionCode: '4', selectionName: '待评价' }
          ],
          callback: (val, node) => {
            this.listQuery.Ywlx = val
          }
        }
      ],
      searchKeyInfo: {
        name: '试卷名/创建人', // searchKey-名称
        onlySearch: true
      },
      insertAuth: true, //新增按钮权限
      loading: false,
      proTableData: [],
      checkMethod: [],
      analysisInfo: {
        finishedNum: '0',
        UnFinishedNum: '0',
        overTime: '0',
        myWork: '0',
        myOverTime: '0',
        DJCSL: '0',
        DXFSL: '0',
        DZGSL: '0',
        DPJSL: '0'
      },
      onlyMywork: true, // 只显示我的工作
      showAddButton: true, //督查部门为质控组时不可以新增检查
      useableDcbm: false,
      applyDataJc: {},
      applyDataXf: {},
      applyDataZg: {},
      applyDataPj: {},
      xtmj1199: '0',
      xtmj1195: '0',
      xtmj1195Value: 0,
      xtmj1200: '0',
      xtmj1201: '0',
      canXF: true,
      canPJ: true,
      isHlbcy: false,
      dictObj: {},
      realDCBMList: [],
      shouldBeCheckAfterPlanDate: true
    }
  },
  computed: {
    ...mapState('plan', ['isRefreshTable'])
  },
  watch: {
    'listQuery.ORGID'(newValue, oldValue) {
      var orgInfo = this.realDCBMList.find((item) => item.id == newValue)
      if (
        orgInfo?.QYZT == '1' &&
        newValue.indexOf('-1112') == -1 // 质控组不能新增临时检查
      ) {
        this.showAddButton = true
      } else {
        this.showAddButton = false
      }
    },
    showTableCheckList(val) {
      this.newTableList = []
      this.tableColumns.forEach((item) => {
        if (val.some((i) => i.key == item.key)) {
          this.newTableList.push(item)
        }
      })
      this.$nextTick(() => {
        if (this.$refs.leftTab) {
          this.$refs.leftTab.doLayout()
        }
      })
    },
    showTableCheckList1(val) {
      this.newTableList1 = []
      this.tableColumns1.forEach((item) => {
        if (val.some((i) => i.key == item.key)) {
          this.newTableList1.push(item)
        }
      })
      this.$nextTick(() => {
        this.$refs.rightTab.doLayout()
      })
    }
  },
  async created() {
    let params = {
      CategoryCode: 'GZTRW_Col'
    }
    await this.$requestApi('GetNqcsConfigList', params)
      .then((res) => {
        this.tableColumns = res.data.map((m) => {
          let flag =
            ['RWLXMC', 'JCXM_MC', 'JCFW_MC', 'JZSJ'].indexOf(m.key) > -1
          return {
            ...m,
            sortable: flag
          }
        })
      })
      .catch((err) => {})

    let params1 = {
      CategoryCode: 'GZTXQ_Col'
    }
    await this.$requestApi('GetNqcsConfigList', params1)
      .then((res) => {
        this.tableColumns1 = res.data
      })
      .catch((err) => {})
    // 获取字典开启数据
    this.dictObj = JSON.parse(localStorage.getItem('dict'))
    // 设置菜单选项
    if (localStorage.getItem('onlyWork')) {
      this.onlyMywork = localStorage.getItem('onlyWork') == '1' ? true : false
    }

    this.GetSxkzList()
    this.newTableList = this.tableColumns
    this.newTableList1 = this.tableColumns1
    this.UserInfo = this.$store.state.user.loginUserInfo
    this.getIsHlbcy()
    this.getSystemSettingInfo()
    //获取默认检查级别
    // await this.getDefaultCheckLevel()
    this.getZkjb()

    this.showTableCheckList = getTableCheckColumns(
      'QcworkBench',
      this.tableColumns
    )

    this.showTableCheckList1 = getTableCheckColumns(
      'QcworkBench1',
      this.tableColumns1
    )
  },
  mounted() {
    if (localStorage.getItem('queryTime')) {
      let obj1 = JSON.parse(localStorage.getItem('queryTime'))
      this.listQuery.StartTime = obj1.StartTime
      this.listQuery.EndTime = obj1.EndTime
    }

    if (localStorage.getItem('querySingleItems')) {
      let obj2 = JSON.parse(localStorage.getItem('querySingleItems'))
      if (obj2.zkjb && obj2.ORGID) {
        this.filterQueryList[1].default = obj2.zkjb
        this.filterQueryList[2].default = obj2.ORGID
      }
    }
  },
  beforeDestroy() {
    this.handleChangeQuery()
  },
  methods: {
    ...mapMutations('plan', ['SET_ISREFRESH_TABLE']),
    handleChangeQuery() {
      localStorage.setItem(
        'querySingleItems',
        JSON.stringify({
          zkjb: this.listQuery.Zkjb,
          ORGID: this.listQuery.ORGID
        })
      )
      localStorage.setItem(
        'queryTime',
        JSON.stringify({
          StartTime: this.listQuery.StartTime,
          EndTime: this.listQuery.EndTime
        })
      )
    },

    // 判断是否禁用开始检查按钮
    canBeStartCheck(rowData) {
      if (!this.shouldBeCheckAfterPlanDate) {
        return true
      }
      // 开始时间为空也可以检查
      if (!rowData.JZSJ) {
        return true
      } else {
        let jsKssj = rowData.JZSJ.split('~')
        if (jsKssj.length == 2) {
          return moment(jsKssj[0]) <= moment()
        }
      }
    },
    GetSxkzList() {
      this.$requestApi('GetSxkzList', {}).then((res) => {
        if (res.success) {
          this.applyDataJc = res.data.DataList.find((i) => i.CJDM == 'JCRWJC')
          this.applyDataXf = res.data.DataList.find((i) => i.CJDM == 'JCWTXF')
          this.applyDataZg = res.data.DataList.find((i) => i.CJDM == 'JCWTZG')
          this.applyDataPj = res.data.DataList.find((i) => i.CJDM == 'ZLGJPJ')
        } else {
          this.$msg(res.message)
        }
      })
    },
    getLastCheckList(val) {
      if (val.length > 0) {
        localStorage.setItem(
          'QcworkBench',
          JSON.stringify({
            showTableCheckList: val
          })
        )
      } else {
        localStorage.removeItem('QcworkBench')
      }
    },
    getLastCheckList1(val) {
      if (val.length > 0) {
        localStorage.setItem(
          'QcworkBench1',
          JSON.stringify({
            showTableCheckList: val
          })
        )
      } else {
        localStorage.removeItem('QcworkBench1')
      }
    },
    getSystemSettingInfo() {
      //获取检查方法
      this.$requestApi('GetXTMJList', { Mjlx: CHECK_METHOD_TYPE_CODE }).then(
        (res) => {
          if (res.success) {
            let data = res.data
            this.checkMethod = data.filter((item) => item.JLZT === '1')
          }
        }
      )
      //质控组是否需要审核
      let Mjdm = '1199,1195,1200,1201,1139,1143,1232,1126'
      this.$requestApi('GetXTMJList', { Mjdm: Mjdm }).then((res) => {
        if (res.success) {
          let dataList = res.data

          // dictObj处理多院区的第一次加载的情况，原来是缓存取的
          this.dictObj = res.data.map((item) => ({
            isOpen: item.JLZT === '1' ? true : false,
            code: item.MJDM,
            defaultValue: item.BZ
          }))
          for (var i = 0; i < dataList.length; i++) {
            var item = dataList[i]
            if (item.MJDM == 1199) {
              this.xtmj1199 = item.JLZT
            }
            if (item.MJDM == 1195) {
              this.xtmj1195 = item.JLZT
              this.xtmj1195Value = item.BZ
            }
            if (item.MJDM == 1200) {
              this.xtmj1200 = item.JLZT
              if (this.xtmj1200 == '1') {
                if (this.isHlbcy) {
                  this.canXF = true
                } else {
                  this.canXF = false
                }
              } else {
                this.canXF = true
              }
            }
            if (item.MJDM == 1201) {
              this.xtmj1201 = item.JLZT
              if (this.xtmj1200 == '1') {
                if (this.isHlbcy) {
                  this.canPJ = true
                } else {
                  this.canPJ = false
                }
              } else {
                this.canPJ = true
              }
            }
          }

          this.shouldBeCheckAfterPlanDate =
            res.data.find((m) => m.MJDM == 1126).JLZT == '1'
        }
      })
    },
    handleCurrentChange(val) {
      if (!val) return
      let obj = {
        Cfxh: val.CFXH
      }
      this.loading = true
      this.$requestApi('GetGZTDetailItemList', obj)
        .then((res) => {
          this.loading = false
          if (res.success) {
            this.proTableData = res.data
          }
        })
        .catch((err) => {
          this.loading = false
        })
    },
    // 查询条件-质控级别
    getZkjb() {
      const that = this
      this.$requestApi('GetCKLevelByUserId')
        .then((res) => {
          if (res.success) {
            that.filterQueryList[1].dataList = res.data.map((m) => {
              return {
                selectionName: m.name,
                selectionCode: m.id
              }
            })
            if (
              !this.filterQueryList[1].dataList.find(
                (i) => i.selectionCode == this.filterQueryList[1].default
              )
            ) {
              this.listQuery.Zkjb = ''
              this.filterQueryList[1].default = ''
            }
            if (res.data && res.data.length > 0) {
              let checkLevel = res.data[0].id
              // 和mixin中this.defaultCheckLevel变量比较
              if (res.data.some((item) => item.id === this.defaultCheckLevel)) {
                checkLevel = this.defaultCheckLevel
              }
              that.listQuery.Zkjb = this.filterQueryList[1].default
                ? this.filterQueryList[1].default
                : checkLevel

              // 这里做字典验证 (是否开启记忆)
              let isMemory = that.dictObj
                ? that.dictObj.find((item) => item.code === 1232)?.isOpen
                : false
              // 如果没有开启记忆功能
              if (!isMemory) {
                let defaultSetting = this.dictObj
                  ? this.dictObj.find((item) => item.code === 1143)?.isOpen
                  : false
                if (defaultSetting) {
                  let defaultZKLevel = this.dictObj
                    .find((item) => item.code === 1143)
                    .defaultValue.slice(-4)

                  //该级别用户是否有权限操作
                  let isPower = this.filterQueryList[1].dataList.find(
                    (item) => item.selectionCode === defaultZKLevel
                  )
                  if (isPower) {
                    this.listQuery.Zkjb = isPower.selectionCode
                  }
                }
                //获取本月的时间
                let nowYear = new Date().getFullYear()
                let nowMouth =
                  new Date().getMonth() + 1 > 9
                    ? new Date().getMonth() + 1
                    : `0${new Date().getMonth() + 1}`
                let lastDay = new Date(nowYear, nowMouth, 0).getDate()
                //1232没开启默认当前月份的时间
                this.listQuery.EndTime = `${nowYear}-${nowMouth}-${lastDay}`
                this.listQuery.StartTime = `${nowYear}-${nowMouth}-01`
              }
              that.changeDCBM(that.listQuery.Zkjb)
            }
          }
        })
        .catch((error) => {
          // that.$msg(error)
        })
    },
    // 查询条件-督查部门
    changeDCBM(zkjb) {
      const that = this
      this.$requestApi('GetOrg', {
        Zkjb: zkjb,
        BusinessType: 'PJ'
      }).then((res) => {
        if (res.success) {
          that.filterQueryList[2].dataList = res.data.map((m) => {
            let child = m.Child
              ? m.Child.map((k) => {
                  return {
                    ...k,
                    QYZT: k.customAttr || k.QYZT,
                    zkjb:
                      this.filterQueryList[1].isMulti && k.zkjb ? k.zkjb : ''
                  }
                })
              : []
            return {
              ...m,
              Child: child,
              QYZT: m.customAttr || m.QYZT
            }
          })

          this.realDCBMList = []
          this.getAllLeafNodes(
            this.filterQueryList[2].dataList,
            this.realDCBMList
          )
          if (
            !this.filterQueryList[2].dataList.find(
              (i) => i.id == this.filterQueryList[2].default
            )
          ) {
            this.filterQueryList[2].default = ''
          }
          if (res.data && res.data.length > 0) {
            that.listQuery.ORGID = this.filterQueryList[2].default
              ? this.filterQueryList[2].default
              : this.realDCBMList[0].id
            this.filterQueryList[2].default = this.listQuery.ORGID
            this.listQuery.HospitalCode =
              this.realDCBMList[0].hospitalCode ||
              this.$store.state.user.HospitalCode
            var orgInfo = this.realDCBMList.find(
              (item) => item.id == that.listQuery.ORGID
            )
            if (orgInfo) {
              if (orgInfo?.QYZT == '1' && orgInfo?.id.indexOf('-1112') == -1) {
                this.showAddButton = true
              } else {
                this.showAddButton = false
              }
            }

            // 1139参数是否开启
            let isOpenDict = this.dictObj.find(
              (item) => item.code === 1139
            )?.isOpen
            if (isOpenDict) {
              let orgData = this.filterQueryList[2].dataList.find((item) =>
                item.id.includes('-1112')
              )
              if (orgData) {
                this.listQuery.ORGID = orgData.id
                this.filterQueryList[2].default = orgData.id
              }
            }
            that.getZZjg()
            that.getDataList()
          }
        } else {
          that.filterQueryList[2].dataList = []
        }
      })
    },
    // 查询受检科室
    getZZjg() {
      if (!this.listQuery.Zkjb) {
        this.filterQueryList[3].dataList = []
        this.listQuery.Jcfw = ''
        return
      }
      this.$requestApi('GetZZjgByZkjbAndUser', {
        UserId: this.UserInfo.UserId,
        Zkjb: this.listQuery.Zkjb
      }).then((res) => {
        if (res.success) {
          this.filterQueryList[3].dataList = res.data
          this.getJCBD()
        }
      })
    },
    // 查询检查表单
    // 查询检查表单 - 后期需更换组件
    getJCBD() {
      this.listQuery.Bddms = ''
      GetJHJCBDList({
        OrgId: this.listQuery.Jcfw, // 根据检查部门做晒选
        Zkjb: this.listQuery.Zkjb,
        Zkzdm: '',
        Jcfs: '',
        Bdmc: '',
        isZHB: '',
        Bhty: true
      }).then((res) => {
        if (res.success) {
          this.filterQueryList[4].dataList = res.data
        }
      })
    },
    // 获取左侧列表
    getDataList(param) {
      let newParam = param ? param : this.listQuery
      let obj = {
        Zkjb: newParam.Zkjb,
        GztZkjb: newParam.Zkjb,
        StartTime: newParam.StartTime,
        EndTime: newParam.EndTime,
        OrgIds: newParam.ORGID,
        Jcfw: newParam.Jcfw,
        Bddms: newParam.Bddms,
        MyWork: this.onlyMywork,
        Ywlx: this.listQuery.Ywlx,
        HospitalCode: this.listQuery.HospitalCode
      }
      if (obj.ORGID) {
        obj.ORGID = obj.ORGID.replace('zzjg_', '').replace('zkz_', '')
      }
      this.tableData = []
      this.proTableData = []
      this.loading = true
      this.SET_ISREFRESH_TABLE(false)
      this.$requestApi('GetMyGZTData', obj)
        .then((res) => {
          if (res.success) {
            this.analysisInfo.myWork = res.data.MyWorkNum
            this.analysisInfo.myOverTime = res.data.MyWorkOverTimeNum
            this.analysisInfo.DJCSL = res.data.DJCSL
            this.analysisInfo.DXFSL = res.data.DXFSL
            this.analysisInfo.DZGSL = res.data.DZGSL
            this.analysisInfo.DPJSL = res.data.DPJSL
          }
        })
        .catch((err) => {})
      this.$requestApi('GetGZTDataList', obj)
        .then((res) => {
          if (res.success) {
            this.tableData = res.data.GZTDataList
            this.analysisInfo.UnFinishedNum = res.data.UnFinishedNum
            this.analysisInfo.finishedNum = res.data.FinishedNum
            this.analysisInfo.overTime = res.data.OverTimeNum
            this.$nextTick(() => {
              if (this.$refs.leftTab) {
                this.$refs.leftTab.setCurrentRow(this.tableData[0])
              }
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 新增检查
    addNewCheck(checkType) {
      if (this.useableDcbm) {
        this.$msg('督查部门为禁用状态不允许新建检查')
        return
      }
      let width = window.innerWidth * 1
      let height = window.innerHeight * 1
      const key = this.$dlg.modal(AddTaskDialog, {
        width: width,
        height: height,
        title: '检查',
        params: {
          checkType: checkType,
          type: 'add',
          listQuery: {
            ZKJB: this.listQuery.Zkjb,
            ORGID: this.listQuery.ORGID,
            HospitalCode: this.listQuery.HospitalCode
          }
        },
        callback: (data) => {
          this.getDataList()
        },
        cancelCallback: () => {
          this.getDataList()
        }
      })
    },
    addPercentage(data) {
      if (data) {
        return `${data}%`
      } else {
      }
    },
    // 开始检查
    onStartCheck(row) {
      if (row.BDZT == 1057) {
        this.$Confirm('当前检查任务的检查表单已停用，是否继续检查？', '提示', {
          showCancelButton: true,
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        })
          .then(() => {
            this.startReallyCheck(row)
          })
          .catch(() => {})
      } else {
        this.startReallyCheck(row)
      }
    },
    async startReallyCheck(row) {
      let width = window.innerWidth * (row.SFDJ === 1 ? 0.5 : 1)
      let height = window.innerHeight * (row.SFDJ === 1 ? 0.6 : 1)
      let dialog = row.SFDJ === 1 ? ApplyDialog : AddTaskDialog
      // todo 接口获取同步检查row数据
      let res = await this.$requestApi('GetZKJCByCFXH', { Cfxh: row.CFXH })
      let params =
        row.SFDJ === 1
          ? {
              dataList: this.applyDataJc,
              row,
              sqnr: `${
                '【' +
                (row.ZKJB == 1001
                  ? '三级质控'
                  : row.ZKJB == 1002
                  ? '二级质控'
                  : '一级质控') +
                '】 ' +
                '【' +
                row.JCXM_MC +
                '】 ' +
                '【' +
                row.JCFW_MC +
                '】 ' +
                '【' +
                row.JCZ +
                '】 ' +
                this.applyDataJc.CJMC +
                '操作'
              }`
            }
          : {
              type: 'check',
              rowData: { ...res.data[0], SHNR: row.SHNR },
              checkType: res.data[0].JCFS,
              listQuery: {
                ZKJB: this.listQuery.Zkjb,
                ORGID: this.listQuery.ORGID
              }
            }
      if (res.success) {
        this.$dlg.modal(dialog, {
          width: width,
          height: height,
          title: `${row.SFDJ === 1 ? '超期操作申请' : '检查'}`,
          params,
          callback: (data) => {
            this.getDataList()
          },
          cancelCallback: () => {
            this.getDataList()
          }
        })
      }
    },
    getIsHlbcy() {
      this.$requestApi('IsHlbCy', {
        UserId: this.UserInfo.UserId,
        HospitalCode: this.UserInfo.HospitalCode
      })
        .then((res) => {
          if (res.success) {
            this.isHlbcy = res.data
          }
        })
        .catch((error) => {
          that.$msg(error)
        })
    },
    // 待下发
    patchPlan(row) {
      if (this.xtmj1199 == '0') {
        let width = window.innerWidth * 1
        let height = window.innerHeight * 1
        this.$dlg.modal(QualityImprovementDialog, {
          title: '改进计划',
          width: width,
          height: height,
          params: {
            cfxh: row.CFXH ? row.CFXH.toString() : '',
            Zkjb: this.listQuery.Zkjb,
            HospitalCode: this.listQuery.HospitalCode
          },
          callback: (data) => {
            this.getDataList()
          },
          cancelCallback: () => {
            this.getDataList()
          }
        })
      } else {
        if (row.SHZT != '1') {
          this.$msg('该数据需审核后才能下发！', 'warning')
          return
        } else {
          let width = window.innerWidth * 1
          let height = window.innerHeight * 1
          this.$dlg.modal(QualityImprovementDialog, {
            title: '改进计划',
            width: width,
            height: height,
            params: {
              cfxh: row.CFXH ? row.CFXH.toString() : '',
              Zkjb: this.listQuery.Zkjb,
              HospitalCode: this.listQuery.HospitalCode
            },
            callback: (data) => {
              this.getDataList()
            },
            cancelCallback: () => {
              this.getDataList()
            }
          })
        }
      }
    },
    // 待整改
    rectification(row) {
      let _sef = this
      let width = window.innerWidth * 1
      let height = window.innerHeight * 1
      this.$dlg.modal(WorkBenchZG, {
        title: '整改',
        width: width,
        height: height,
        params: {
          cfxh: row.CFXH,
          zkjb: _sef.listQuery.Zkjb
        },
        callback: (data) => {
          let refresh = data && data.type
          if (refresh) {
            this.getDataList()
          }
        },
        cancelCallback: () => {
          this.getDataList()
        }
      })
    },
    // 待评价
    judgeAction(row) {
      let _sef = this
      let width = window.innerWidth * 1
      let height = window.innerHeight * 1
      this.$dlg.modal(workBenchGZPJ, {
        title: '评价',
        width: width,
        height: height,
        params: {
          cfxh: row.CFXH,
          pjzkjb: _sef.listQuery.Zkjb,
          orgid: _sef.listQuery.ORGID
        },
        callback: (data) => {
          let refresh = data && data.type
          if (refresh) {
            _sef.getDataList()
          }
        },
        cancelCallback: () => {
          this.getDataList()
        }
      })
    },
    setOnlyWork() {
      //设置记忆
      let setValue = this.onlyMywork == true ? 1 : 0
      localStorage.setItem('onlyWork', setValue)
      this.getDataList()
    },
    getAllLeafNodes(nodes, leafNodes) {
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i]

        if (!node.Child || node.Child.length === 0) {
          // 当前节点没有子节点，认为是叶子节点，将其添加到数组中
          leafNodes.push(node)
        } else {
          // 遍历子节点
          this.getAllLeafNodes(node.Child, leafNodes)
        }
      }
    },
    buildExportParam(type) {
      let newParam = this.listQuery
      let obj = {
        UserId: this.UserInfo.UserId,
        Zkjb: newParam.Zkjb,
        GztZkjb: newParam.Zkjb,
        StartTime: newParam.StartTime,
        EndTime: newParam.EndTime,
        OrgIds: newParam.ORGID,
        Jcfw: newParam.Jcfw,
        Bddms: newParam.Bddms,
        MyWork: this.onlyMywork,
        Ywlx: this.listQuery.Ywlx,
        HospitalCode: this.listQuery.HospitalCode,
        GztZkjb: this.listQuery.Zkjb,
        FileType: type,
        ExportColumns: JSON.stringify(this.newTableList)
      }
      if (obj.OrgIds) {
        obj.OrgIds = obj.OrgIds.replace('zzjg_', '').replace('zkz_', '')
      }
      return obj
    },
    exportFile(type) {
      let params = this.buildExportParam(type)
      DownFile('NQCS/Download?act=ExportGZT', params)
    },
    print() {
      let params = this.buildExportParam('PDF')
      Print('NQCS/Print?act=ExportGZT', params).then((res) => {
        let width = window.innerWidth
        let height = window.innerHeight
        const key = this.$dlg.modal(PdfDialog, {
          width: width,
          height: height,
          title: '文件打印',
          params: {
            pdfUrl: res.data.FilePath
          },
          callback: (data) => {
            if (this.isRefreshTable) {
              this.getDataList(this.listQuery)
            }
          },
          cancelCallback: () => {}
        })
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-page {
  // height: 93vh;
}
.benchTop {
  width: 100%;
  padding: 10px 10px;
  border-radius: 4px;
  background-color: rgb(233, 227, 227);
}
.ver-line {
  width: 1px;
  display: inline-block;
  height: 19px;
  background: rgb(168, 167, 238);
}
.option-zoom {
  margin-top: 16px;
  text-align: right;
}
.option-zoom .w-button + .w-button {
  margin-left: 16px;
}
.table-container {
  background-color: white;
}
.tool-container {
  margin-top: 6px;
  margin-bottom: 6px;
}
.search-container {
  background-color: white;
  padding: 10px;
}
// /deep/ .w-table__fixed-right .w-table__row td:not(.is-hidden):last-child {
//   border-left: none !important;
// }
/deep/ .w-table--border thead th:nth-last-child(3) {
  border-right: 1px solid #c9c9c9 !important;
}
.red-item {
  color: red;
  :hover {
    color: red;
  }
}
</style>
